import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CrmThemeContext = createContext(null);

export const useCrmTheme = () => {
  const context = useContext(CrmThemeContext);
  if (!context) throw new Error('useCrmTheme must be used within CrmThemeProvider');
  return context;
};

export const CrmThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('crm_theme') || 'dark');
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem('crm_theme', theme);
  }, [theme]);

  // Apply dark mode globally ONLY when the user is inside /crm routes. All other
  // routes (Pathways, public site, blog) always render in light mode so that
  // shadcn Cards and other shared components don't inherit CRM dark variables.
  useEffect(() => {
    const root = document.documentElement;
    const insideCrm = location.pathname.startsWith('/crm');
    if (insideCrm && theme === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
    }
  }, [theme, location.pathname]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
    <CrmThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === 'dark' }}>
      {children}
    </CrmThemeContext.Provider>
  );
};

// Kept as a no-op for backwards compatibility — CrmThemeProvider now handles
// route-scoped theming automatically.
export const useForceLightMode = () => {};
